<template>
    <div class="container">
        <div class="row">
            <div class="col-12" :style="`height: calc(30vh - 32px); margin-top: calc(40vh - 100px)`">
                <h1 class="text-center text-upper-case text-categories-red">404</h1>
                <h2 class="text-center erro404 text-upper-case text-categories-red">Desculpe, essa Página não está disponível</h2>
            </div>
        </div>
        <div class="row d-flex justify-content-center pb-5 mt-5 mt-xl-0">
            <b-button class="col-6 col-md-3 col-xl-2 mb-1 mt-0 btn-opacidade text-upper-case button font-glacial-regular" to="/">HOME</b-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            post: null
        }
    },
    
}
</script>
<style>
    .erro404{
        width:100%;
    }
    .button {
        background-color: #ff0004;
        border: none;
        color: white;
        padding: 15px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        margin: 4px 2px;
        cursor: pointer;
        border-radius: 50px;
    }
    .button.btn-secondary:hover {
        color: #fff;
        background-color: #ff0004;
        border-color: #ff0004;
    }
    .button.btn-secondary:not(:disabled):not(.disabled).active{
        background-color: #ff0004;
        border-color: #ff0004;
    }
</style>


// WEBPACK FOOTER //
// src/components/Erro404.vue